export default "__VITE_ASSET__tw8$c8Tb__"